import { CountPresentationReviewByStatusQuery } from 'generated/graphql';
import React, { FunctionComponent, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { Label, Loader } from 'semantic-ui-react';
import { CountProPresentationReviewByStatusView } from './count-pro-presentation-review-by-status-view';

type Props = {
  countByStatus?: CountPresentationReviewByStatusQuery['countProReviewByStatus'];
  loading: boolean;
  proPresentationId: number;
};

export const CountProPresentationReviewByStatusContainer: FunctionComponent<
  Props
> = ({ countByStatus, loading, proPresentationId }) => {
  const navigate = useNavigate();

  const okCount = useMemo(() => {
    return countByStatus?.find((thisByStatus) => thisByStatus.status === 'ok')
      ?.count;
  }, [countByStatus]);

  const draftCount = useMemo(() => {
    return countByStatus?.find(
      (thisByStatus) => thisByStatus.status === 'draft',
    )?.count;
  }, [countByStatus]);

  const onProReviewFilterClicked = useCallback(
    (status: string) => {
      navigate(`/reviews?presentationId=${proPresentationId}&status=${status}`);
    },
    [proPresentationId],
  );

  if (loading) {
    return (
      <Label
        style={{ marginBottom: '0px', textDecoration: 'none' }}
        color="grey"
        pointing="below"
      >
        &nbsp;&nbsp;
        <Loader active inverted size="mini" />
      </Label>
    );
  }

  return (
    <CountProPresentationReviewByStatusView
      countByStatus={countByStatus}
      draftCount={draftCount}
      okCount={okCount}
      onProReviewFilterClicked={onProReviewFilterClicked}
    />
  );
};
